function assertNever(_) {
  throw new Error("Exhaustive Error: This line should never be reached.");
}
export {
  assertNever
};
//# sourceMappingURL=assertNever.js.map
